// Multiple File Uploader Component

import { Box, Button, Stack } from "@mui/material";
import UploadIcon from "@mui/icons-material/UploadSharp";

import { FileDisplay } from "./file-display";

export const MultipleFileUploader = <T,>({
  name,
  onChange,
  files = [],
  addFiles,
  removeFile,
}: {
  name: string;
  onChange: (value: T) => void;
  files?: File[];
  addFiles?: (files: File[]) => void;
  removeFile?: (fileName: string) => void;
}) => {
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileList = e.target.files;
    const newFiles = fileList ? Array.from(fileList) : [];

    if (addFiles) {
      addFiles(newFiles);
    }

    // Signal form state with selected file names
    onChange(newFiles.map((f) => f.name) as unknown as T);
  };

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={1.5}
      alignItems={{ xs: "stretch", md: "flex-start" }}
      sx={{ mt: 1 }}
    >
      <Box sx={{ minWidth: { md: 150 }, flexShrink: 0 }}>
        <Button
          variant="contained"
          component="label"
          startIcon={<UploadIcon />}
          fullWidth
        >
          <input
            hidden
            name={name}
            type="file"
            multiple
            onChange={handleOnChange}
          />
          Select Files
        </Button>
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <FileDisplay
          files={files ?? []}
          removeFileFromArr={(fileName) => removeFile && removeFile(fileName)}
        />
      </Box>
    </Stack>
  );
};
